import React, { useCallback, useState } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { convertProduct2Item } from '../../../../helper'
import { selectIsAustrianCompany, selectIsNeededZIndex } from '../../../../redux/selector/system'
import TextInputControlled from '../../inputs/TextInput/controlled'
import { validatePrice } from './helper'
import ButtonsModal from '../../modal/ButtonsModal'
import { CustomProductForm } from './index.styled'
import CurrencyInputControlled from '../../inputs/CurrencyInput/controlled'

const EVENT_Z_INDEX = 83

const ModalCustomProduct = React.memo(({ isOpen, close, addProduct, addRemarkToItem, itemExist }) => {
	const { t } = useTranslation()
	const isNeededZIndex = useSelector(selectIsNeededZIndex(EVENT_Z_INDEX))
	const isAustrianCompany = useSelector(selectIsAustrianCompany)
	const [title, setTitle] = useState('')
	const [price, setPrice] = useState('0,00')
	const [priceError, setPriceError] = useState('')
	const [isEmptyTitle, setIsEmptyTitle] = useState(false)

	const handleReset = useCallback(() => {
		setTitle('')
		setPrice('0,00')
		setPriceError('')
		setIsEmptyTitle(false)
	}, [])

	const handleChangeTitle = useCallback((e) => {
		const value = e.target.value
		if (isEmptyTitle && value.trim()) setIsEmptyTitle(false)
		setTitle(value)
	}, [isEmptyTitle])

	const handleChangePrice = useCallback(() => {
		setPriceError('')
	}, [])

	const handleChooseItemType = useCallback((e, itemType) => {
		if (e) e.preventDefault()
		const isBottleDeposit = itemType === 'BOTTLE_DEPOSIT'
		const trimmedTitle = title.trim()
		const { error, numeric } = validatePrice(price, { t, isBottleDeposit })
		if (!trimmedTitle) {
			setIsEmptyTitle(true)
			return
		}
		if (error) {
			setPriceError(error)
			return
		}

		if (itemType === 'COMMENT') {
			addRemarkToItem(title)
		} else {
			let customProduct =
				convertProduct2Item(
					{ productId: 'custom', productType: itemType, title: title },
					1, numeric, 0, [])
			addProduct(customProduct)
		}
		handleReset()
		close()
	}, [price, handleReset, addRemarkToItem, addProduct, close, title, t])

	const buttons = [
		{ icon: 'main-dish', text: t('product.form.main.type_options.product'), onClick: (e) => handleChooseItemType(e, 'MAIN_DISH'), show: true, testId: 'mainDishButton' },
		{ icon: 'BEVERAGE', text: t('product.form.main.type_options.drink'), onClick: (e) => handleChooseItemType(e, 'BEVERAGE'), show: true, testId: 'beverageButton' },
		{ icon: 'bottle-deposit', text: t('product.form.main.type_options.deposit'), onClick: (e) => handleChooseItemType(e, 'BOTTLE_DEPOSIT'), show: true, testId: 'bottleDepositButton' },
		{ icon: 'tobacco', text: t('product.form.main.type_options.tobacco'), onClick: (e) => handleChooseItemType(e, 'TOBACCO'), show: true, testId: 'tobaccoButton' },
		{ icon: 'main-dish', text: t('product.form.main.type_options.basicFood'), onClick: (e) => handleChooseItemType(e, 'BASIC_FOOD'), show: isAustrianCompany, testId: 'basicFoodButton' },
		{ icon: 'change', text: t('product.form.main.type_options.comment'), onClick: (e) => handleChooseItemType(e, 'COMMENT'), show: itemExist, testId: 'commentButton' },
	]

	const handleClose = useCallback(() => {
		handleReset()
		close()
	}, [handleReset, close])

	return (
		<>
			<ButtonsModal isOpen={isOpen}
										size="small"
										id="custom-product-modal"
										close={handleClose}
										title={t('Cart.Buttons.extras')}
										zIndex={EVENT_Z_INDEX}
										buttons={buttons}>
				<CustomProductForm>
					<TextInputControlled name="title"
															 tabIndex="1"
															 label={t('product.table.description')}
															 value={title}
															 onChange={handleChangeTitle}
															 errorMessage={isEmptyTitle && t('app.validation.required')}
															 autoFocus={isNeededZIndex}
															 color="gray" />
					<CurrencyInputControlled name="price"
																	 tabIndex="2"
																	 label={t('Cart.price')}
																	 value={price}
																	 allowNegative={true}
																	 setValue={setPrice}
																	 onChange={handleChangePrice}
																	 errorMessage={priceError}
																	 color="gray" />
				</CustomProductForm>
			</ButtonsModal>
		</>
	)
})

ModalCustomProduct.displayName = 'ModalCustomProduct'
export default ModalCustomProduct
